import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet"; // Helmet for managing metadata dynamically
import axios from "../axios";
import './PageDetail.css';

const PageDetail = () => {
  const { slug } = useParams(); // Extract slug from URL
  const [page, setPage] = useState(null); // State for page content fetched from API
  const [userLocation, setUserLocation] = useState("Global"); // Default user location

  useEffect(() => {
    // Fetch page content based on slug
    const fetchPageContent = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/pages/${slug}/`);
        setPage(response.data);
      } catch (error) {
        console.error("Error fetching page content:", error);
      }
    };

    // Fetch user location based on IP
    const fetchUserLocation = async () => {
      try {
        const locationResponse = await axios.get('https://ip-api.com/json/');
        const userCity = locationResponse.data.city || "Global";
        setUserLocation(userCity);
        console.log(`User's current location: ${userCity}`);
      } catch (error) {
        console.error("Error fetching user location:", error);
        setUserLocation("Global");
      }
    };

    fetchPageContent();
    fetchUserLocation();
  }, [slug]);

  // Generate location-specific keywords for SEO
  const generateLocationSpecificKeywords = (location) => {
    if (!location) return "default, keywords, react, seo";
    return `Data Visualization in ${location}, Machine Learning Services in ${location}, Analytics Solutions in ${location}, Dynamic Website Development in ${location}`;
  };

  return (
    <div className="page-content-wrapper">
      <div className="page-content">
        {page ? (
          <>
            <Helmet>
              <title>{`${String(page?.title || "MY727 Infotech")} | ${String(userLocation || "India")}`}</title>

              <meta
                name="description"
                content={
                  page?.description ||
                  `Explore our services in ${userLocation || "India"}. We provide tailored solutions for your needs.`
                }
              />

              <meta
                name="keywords"
                content={generateLocationSpecificKeywords(userLocation || "India")}
              />

              <meta
                property="og:title"
                content={`${String(page?.title || "MY727 Infotech")} | ${String(userLocation || "India")}`}
              />

              <meta
                property="og:description"
                content={
                  page?.description ||
                  `Explore tailored solutions for businesses in ${userLocation || "India"}.`
                }
              />

              <meta property="og:url" content={window.location.href} />
              <meta property="og:type" content="article" />
              <meta name="twitter:card" content="summary_large_image" />
            </Helmet>

            {/* page.title is intentionally not rendered here — it's used only in
                <Helmet> above for the browser tab / SEO / social sharing */}
            <div
              className="page-body"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          </>
        ) : (
          <div className="loading-container">
            <p>Loading page...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageDetail;